/* eslint-disable no-useless-escape */
import styles from "../../../_common/CrudFormStyles.module.scss";
import { useEffect } from "react";
import { Form, Tabs } from "antd";
import { translateKey as t } from "../../../../../locales/translation";
import { ClientsController } from "../../ClientsController";
import { observer } from "mobx-react";
import JobDataImportTab from "./JobDataImportTab";
import CustomFieldsTab from "./CustomFieldsTab";
import GeneralTab from "./GeneralTab";

const { TabPane } = Tabs;

const ClientsForm = observer(({ controller }: { controller: ClientsController }) => {
  const [form] = Form.useForm();

  useEffect(() => {}, []);

  return (
    <Form form={form} className={styles.form} requiredMark={false} initialValues={controller.selectedClient} layout="vertical">
      <Tabs
        defaultActiveKey="general"
        activeKey={controller.currentTab}
        onChange={(key) => controller.setCurrentTab(key)}
        animated={false}
        size="small"
        tabBarStyle={{ margin: 0 }}
        style={{ padding: 0 }}
        className="formTabs"
      >
        <TabPane tab={t("lblGeneral", "General")} key="general" forceRender={true}>
          <GeneralTab controller={controller} form={form} />
        </TabPane>

        {controller.selectedClient?.jobDataImport && (
          <TabPane tab={t("lblJobDataImport", "Job Data Import")} key="jobDataImport" forceRender={true}>
            <JobDataImportTab controller={controller} form={form} />
          </TabPane>
        )}

        {controller.selectedClient?.customFields && (
          <TabPane tab={t("lblCustomFields", "Custom Fields")} key="customFields" forceRender={true}>
            <CustomFieldsTab controller={controller} form={form} />
          </TabPane>
        )}

        {/* 
      <RenderEndOfDayRoutesTab/>
      <RenderMapEditorTab/>
       */}
      </Tabs>
    </Form>
  );
});

export { ClientsForm };
